import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Heading from '../Heading';
import { CategoryLabelProvider, LabelType } from '../LabelProvider';
import { useProductBrowser } from '../ProductBrowserContext';
import { getTopLevelCategory } from '../utils/category';
var CategoryHeading = styled(Heading).withConfig({
  displayName: "TopLevelCategoryHeading__CategoryHeading",
  componentId: "sc-16hnp9m-0"
})(["\n  text-align: left;\n  padding-bottom: 7px;\n"]);
var labelOptions = {
  labelType: LabelType.TOP_LEVEL_CATEGORY_HEADING
};

function TopLevelCategoryHeading(_ref) {
  var activeCategoryFromProps = _ref.activeCategory,
      rest = _objectWithoutProperties(_ref, ["activeCategory"]);

  var productBrowserCtx = useProductBrowser();
  var categoryLabelCtx = CategoryLabelProvider.useLabels();
  var activeCategory = activeCategoryFromProps;

  if (productBrowserCtx && productBrowserCtx.activeCategory) {
    if (!activeCategoryFromProps) {
      activeCategory = productBrowserCtx.activeCategory;
    }
  }

  var category = useMemo(() => getTopLevelCategory(activeCategory), [activeCategory]);
  return /*#__PURE__*/React.createElement(CategoryHeading, _extends({
    level: 2
  }, rest), categoryLabelCtx.renderLabel(category, labelOptions));
}

TopLevelCategoryHeading.propTypes = {
  activeCategory: PropTypes.object
};
export default TopLevelCategoryHeading;